export default __webpack_public_path__ + "static/media/ghoulishfeast.7ca77e26.png";